import React, { Component } from 'react';
import cloneDeep from 'lodash/cloneDeep';
import Modal from '@cloudscape-design/components/modal';
import Input from '@cloudscape-design/components/input';
import Button from '@cloudscape-design/components/button';
import Box from '@cloudscape-design/components/box';
import SpaceBetween from '@cloudscape-design/components/space-between';
import FormField from '@cloudscape-design/components/form-field';
import Textarea from '@cloudscape-design/components/textarea';
import Tabs from '@cloudscape-design/components/tabs';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { brandLicensesAddModalStore } from '../stores/brandLicensesAddModal';
import ColumnLayout from "@cloudscape-design/components/column-layout";
import { Container } from "react-bootstrap";

class BrandLicensesAddModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			jsonError: '',
		};
	}


	resetFormFields = () => {
		const { setBrandLicensesAddModal, brandLicensesAddModal } = this.props;
		setBrandLicensesAddModal({
			...brandLicensesAddModal,
			show: false,
			formData: {
				company: '',
				license_name: '',
				license_number: '',
				license_country: '',
				license_address: '',
				license_url: '',
				license: '',
				image_path: '',
				domain: '',
				ltd: '',
				translate: '',
			},
			jsonData: '',
			error: {
				text: '',
				code: 0,
				timestamp: 0,
			},
		});
		this.setState({ jsonError: '' });
	};

	updateFormField = (key, value) => {
		const { brandLicensesAddModal, setBrandLicensesAddModal } = this.props;
		const updatedState = cloneDeep(brandLicensesAddModal);
		updatedState.formData[key] = value;
		updatedState.jsonData = JSON.stringify(updatedState.formData, null, 2);
		setBrandLicensesAddModal(updatedState);
	};

	handleJsonChange = (value) => {
		const { brandLicensesAddModal, setBrandLicensesAddModal } = this.props;
		const updatedState = cloneDeep(brandLicensesAddModal);
		updatedState.jsonData = value;
		try {
			const parsed = JSON.parse(value);
			updatedState.formData = parsed;
			this.setState({ jsonError: '' });
		} catch (error) {
			this.setState({ jsonError: 'Invalid JSON format' });
		}
		setBrandLicensesAddModal(updatedState);
	};

	addBrandLicense = async () => {
		const { brandLicensesAddModal, Interface } = this.props;
		const { jsonError } = this.state;

		if (jsonError) {
			Interface.addNoty('Error', 'Please fix JSON before saving');
			return;
		}

		try {
			const body = {
				...brandLicensesAddModal.formData,
			};

			const result = await Interface.request('set', {
				class: 'data',
				module: 'brandLicenses',
				method: 'add',
			}, body);

			Interface.addNoty('Success', 'Brand license added successfully');
			Interface.loadBrandLicenses();
			this.resetFormFields();
		} catch (error) {
			Interface.addNoty('Error', error.text || error.toString());
		}
	};

	render() {
		const { brandLicensesAddModal, setBrandLicensesAddModal } = this.props;
		const { jsonError } = this.state;

		const formFields = [
			{ key: 'company', label: 'Company' },
			{ key: 'license_name', label: 'License Name' },
			{ key: 'license_number', label: 'License Number' },
			{ key: 'license_country', label: 'License Country' },
			{ key: 'license_address', label: 'License Address' },
			{ key: 'license_url', label: 'License URL' },
			{ key: 'license', label: 'License Text', textarea: true },
			{ key: 'image_path', label: 'Image Path' },
			{ key: 'domain', label: 'Domain' },
			{ key: 'ltd', label: 'LTD', textarea: true },
			{ key: 'translate', label: 'Translate', textarea: true },
		];

		return (
			<Modal
				visible={brandLicensesAddModal.show}
				size="medium"
				onDismiss={() => setBrandLicensesAddModal({ ...brandLicensesAddModal, show: false })}
				header="Add Brand License"
				footer={
					<Box float="right">
						<SpaceBetween direction="horizontal" size="xs">
							<Button variant="normal" onClick={this.resetFormFields}>
								Cancel
							</Button>
							<Button variant="primary" onClick={this.addBrandLicense}>
								Save License
							</Button>
						</SpaceBetween>
					</Box>
				}
			>
				<Container>
					<Tabs
						tabs={[
							{
								label: 'Form',
								id: 'form',
								content: (
									<SpaceBetween direction="vertical" size="l">
										{formFields.map(({ key, label, description, textarea }) => (
											<FormField
												key={key}
												label={label}
												description={description}
												stretch={textarea}
											>
												{textarea ? (
													<Textarea
														value={brandLicensesAddModal.formData[key]}
														onChange={({ detail }) => this.updateFormField(key, detail.value)}
														rows={4}
													/>
												) : (
													<Input
														value={brandLicensesAddModal.formData[key]}
														onChange={({ detail }) => this.updateFormField(key, detail.value)}
													/>
												)}
											</FormField>
										))}
									</SpaceBetween>
								),
							},
							{
								label: 'JSON Editor',
								id: 'json',
								content: (
									<FormField
										label="JSON Editor"
										description="Edit license data in JSON format"
										errorText={jsonError}
										stretch
									>
										<Textarea
											value={brandLicensesAddModal.jsonData || JSON.stringify(brandLicensesAddModal.formData, null, 2)}
											onChange={({ detail }) => this.handleJsonChange(detail.value)}
											rows={20}
											style={{ fontFamily: 'monospace' }}
										/>
									</FormField>
								),
							},
						]}
					/>
				</Container>
			</Modal>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const brandLicensesAddModal = useRecoilValue(brandLicensesAddModalStore);
		const setBrandLicensesAddModal = useSetRecoilState(brandLicensesAddModalStore);

		return (
			<Component
				{...props}
				setBrandLicensesAddModal={setBrandLicensesAddModal}
				brandLicensesAddModal={brandLicensesAddModal}
			/>
		);
	};
}

export default withRecoil(BrandLicensesAddModal);